import { Injectable } from '@angular/core';
import { CustomFeatureSectionDTO, FuncionalidadPersonalizacionDTO, SolicitudAutorizacionDTO } from '@shared/dto';
import { FuncionalidadPersonalizacion } from '@shared/models/funcionalidadPersonalizacion';
import { BehaviorSubject } from 'rxjs';
import { Cookies } from '..';

@Injectable({
  providedIn: 'root'
})
export class CustomPanelProvider {
 
  lenguage =  JSON.parse(localStorage.getItem("currentUser")).compania.paisIdioma;
 
  
  //Variables a compartir entre componentes
  private funcionalidadPersonalizadas = new BehaviorSubject<Array<FuncionalidadPersonalizacion>>([]);
  private customPanelSections       = new BehaviorSubject<Array<CustomFeatureSectionDTO>>([]);
  private isOpen                      = new BehaviorSubject<boolean>(false);

  currentfuncionalidadPersonalizadas  = this.funcionalidadPersonalizadas.asObservable();
  currentCustomPanelSections        = this.customPanelSections.asObservable();
  currentIsOpen                       = this.isOpen.asObservable();

  constructor() { }

  changeFuncionalidadPersonalizadas(funcionalidadPersonalizadas : Array<FuncionalidadPersonalizacion>) {
    funcionalidadPersonalizadas.forEach(fp => {

      let nombre = fp.funcionalidadPersonalizacionId != null 
                    ? fp.nombre
                    : (this.lenguage == "en" ? fp.etiqueta.nombreEn : fp.nombre);

      fp.nombre = nombre;
    })
    this.funcionalidadPersonalizadas.next(funcionalidadPersonalizadas);
  }

  changeCurrentCustomPanelSections(customPanelSections : Array<CustomFeatureSectionDTO>) {  
    this.customPanelSections.next(customPanelSections);
  }

  changeIsOpen(isOpen: boolean){
    this.isOpen.next(isOpen);
  }

}
